import { createStore } from "vuex";
import auth from "@/store/auth";
import nav from "@/store/nav";

const store = createStore({
  state: {
    loading: false,
    message: "",
  },
  mutations: {
    loading(state, { message, loadingState }) {
      state.message = message;
      state.loading = loadingState;
    },
  },
  actions: {
    startLoading({ commit }, message) {
      commit("loading", { message, loadingState: true });
    },
    stopLoading({ commit }) {
      commit("loading", { message: "", loadingState: false });
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    loadingMessage(state) {
      return state.message;
    },
  },
  modules: {
    auth, nav,
  },
});

store.dispatch("init");
export default store;
